import {PageDescription} from './page-description';

export class AsbCCUrl {
  static readonly URLS: PageDescription[] = [];

  public static url(urlTemplate: string, args: { [x: string]: any; }) {
    return urlTemplate.replace(/:[^\/]+/g, function (m) {
      return args[m.substring(1)];
    });
  }

  public static label(url: string) {
    let label: string = url;
    this.URLS.forEach(function (desc) {
      if ('/' + desc.path.toLowerCase() === url) {
        label = desc.label;
        return;
      }
    });
    return label;
  }
}
